import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NonStaticInterceptor } from './nonstatic.http-interceptor';

@Injectable()
export class ParseJsonInterceptor extends NonStaticInterceptor implements HttpInterceptor {
  private dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)$/;
  private utcDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/;

  protected internalIntercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.convertDates(event.body);
        }
      })
    );
  }
  private convertDates(object: Object) {
    if (!object || !(object instanceof Object)) {
      return;
    }

    if (object instanceof Array) {
      for (const item of object) {
        this.convertDates(item);
      }
    } else {
      for (const key of Object.keys(object)) {
        // No se puede definir como constante por si hay que dar el cambiazo de un numero por fecha
        // const value = object[key];
        const value = object[key];
        // TODO: Excluimos identifier porque el servicio de circuitos tiene IDs numericos que se confunden con fechas
        if (key === 'identifier') {
          continue;
        } else if (value instanceof Array) {
          for (const item of value) {
            this.convertDates(item);
          }
        } else if (value instanceof Object) {
          this.convertDates(value);
        } else if (typeof value === 'number') {
          try {
            // TODO deshacer la ñapa e identificar los numeros que son fecha de forma mas cientifica
            if (value > 100000000000) {
              //            console.log('Encontrado numero que se trata como Date', value);
              let date = new Date(value);
              if (date) {
                object[key] = date;
              }
            }
          } catch (error) { }
        }
      }
    }
  }
}
